import tours from './tours';

const wlMediaSources = {
  [tours.WELCOME_TOUR]: [
    {
      mobile: '/images/welcome-tour/wl-mob-first-step.png',
      desktop: '/images/welcome-tour/wl-desktop-first-step.png',
    },
    {
      mobile: 'https://cdn.ws-platform.net/welcome-tour/wl-welcome-tour-mobile-add.mp4',
      desktop: 'https://cdn.ws-platform.net/welcome-tour/wl-welcome-tour-desktop-add.mp4',
    },
    {
      mobile: 'https://cdn.ws-platform.net/welcome-tour/wl-welcome-tour-mobile-modify.mp4',
      desktop: 'https://cdn.ws-platform.net/welcome-tour/wl-welcome-tour-desktop-modify.mp4',
    },
    {
      mobile: 'https://cdn.ws-platform.net/welcome-tour/wl-welcome-tour-mobile-brand.mp4',
      desktop: 'https://cdn.ws-platform.net/welcome-tour/wl-welcome-tour-desktop-brand.mp4',
    },
    {
      mobile: 'https://cdn.ws-platform.net/welcome-tour/wl-welcome-tour-mobile-publish.mp4',
      desktop: 'https://cdn.ws-platform.net/welcome-tour/wl-welcome-tour-desktop-publish.mp4',
    },
    {
      mobile: 'https://cdn.ws-platform.net/welcome-tour/wl-welcome-tour-mobile-grow.mp4',
      desktop: 'https://cdn.ws-platform.net/welcome-tour/wl-welcome-tour-desktop-grow.mp4',
    },
  ],
  [tours.MULTILINGUAL_TOUR]: [
    {
      mobile: '/images/multilingual-tour/intro-mobile.png',
      desktop: '/images/multilingual-tour/intro-desktop.png',
    },
    {
      mobile: 'https://cdn.ws-platform.net/multilingual-tour/translate-mobile.mp4',
      desktop: 'https://cdn.ws-platform.net/multilingual-tour/translate-desktop-wl.mp4',
    },
    {
      mobile: 'https://cdn.ws-platform.net/multilingual-tour/navigate-mobile-wl.mp4',
      desktop: 'https://cdn.ws-platform.net/multilingual-tour/navigate-desktop-wl.mp4',
    },
    {
      mobile: 'https://cdn.ws-platform.net/multilingual-tour/adapt-mobile.mp4',
      desktop: 'https://cdn.ws-platform.net/multilingual-tour/adapt-desktop-wl.mp4',
    },
  ],
};

export default wlMediaSources;
